import { ServiceRow } from './ServiceRow';
import { ServiceActivation } from '../../../../../codegen/vehicles';
import { PaymentMethod } from '../../../../../models';
import { CardDetails } from './CardDetails';

type ActiveServiceProps = {
  activeService: ServiceActivation;
  paymentMethods: PaymentMethod[];
};

export const ActiveService = ({
  activeService,
  paymentMethods,
}: ActiveServiceProps) => {
  const assignedPaymentMethods = activeService.paymentMethodAssignments
    .map((pa) => paymentMethods.find((p) => p.id === pa.paymentMethodId))
    .filter((p) => !!p);

  return (
    <>
      <ServiceRow service={activeService.serviceType} />
      {assignedPaymentMethods.map((paymentMethod) => (
        <CardDetails
          key={paymentMethod.id}
          paymentPartner={paymentMethod.paymentPartner}
          lastFourDigits={paymentMethod.lastFourDigits}
          expiry={paymentMethod.expiry}
        />
      ))}
    </>
  );
};
